function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M24.5,49A24.5,24.5,0,1,1,37.714,3.881a1.671,1.671,0,0,1-1.806,2.813,21.154,21.154,0,1,0,9.748,17.812c0-.7-.033-1.388-.1-2.067a1.67,1.67,0,1,1,3.325-.323Q49,23.3,49,24.506A24.527,24.527,0,0,1,24.5,49Zm0,0",
  transform: "translate(0 -0.008)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M161.031,49.186a1.658,1.658,0,0,1-1.18-.49L149.829,38.674a1.671,1.671,0,0,1,2.363-2.363l8.842,8.842,23.315-23.316a1.671,1.671,0,0,1,2.363,2.363l-24.5,24.5A1.673,1.673,0,0,1,161.031,49.186Zm0,0",
  transform: "translate(-133.75 -19.12)"
});

var SvgEntregado = function SvgEntregado(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53.452,
    height: 48.996,
    viewBox: "0 0 53.452 48.996",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEntregado, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/entregado.0c158a7f.svg";
export { ForwardRef as ReactComponent };